import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { ChapterPayload, IoniconsOutline, StoreTemplateStatus, TemplateGroup, UiWidget } from '@pt/pt-models';
import { GetChapterResponse } from 'it/primatoo/openapi/api/org/schemas/common/docs/GetChapterResponse';
import { Store } from '@ngrx/store';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'pt-editor-sidebar-panel-group',
  templateUrl: './editor-sidebar-panel-group.component.html',
  styleUrls: [`editor-sidebar-panel-group.component.scss`]
})
export class EditorSidebarPanelGroupComponent implements OnChanges, AfterViewInit {
  public readonly groupIdPrefix = 'sidebar-editor-group_';

  @Input() chapter: GetChapterResponse;
  @Input() selectedGroup: TemplateGroup;
  @Input() status: StoreTemplateStatus;
  @Output() selectChapterGroup = new EventEmitter<TemplateGroup>();
  @ViewChild('acc') acc;

  public currentEditGroup: TemplateGroup;
  public payload: ChapterPayload;
  public disabledChangeGroup: boolean;
  public IconCheck = IoniconsOutline.check;
  public IconWarning = IoniconsOutline.warning;
  public enabledWidgetInternalId: number[] = [];

  constructor(private store: Store) {
  }


  ngAfterViewInit(): void {
    this.expandCurrentGroup();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.status) {
      this.disabledChangeGroup = this.status.activedEditWidgetId !== null && this.status.activedEditWidgetId !== undefined;
      this.enabledWidgetInternalId = this.status.enabledWidgetId;
      this.setEditGroup(this.status);
    }
    if (changes.selectedGroup && changes.selectedGroup.currentValue) {
      this.clickGroup(this.selectedGroup, false);
    }

    if (changes.chapter && changes.chapter.currentValue) {
      this.initialize(changes.chapter.currentValue);
    }
  }

  isCompleted(internalId: number): boolean {
    return this.status
      && this.status.loadedWidgetId !== null && this.status.loadedWidgetId !== undefined
      && internalId !== null && internalId !== undefined
      && this.status.loadedWidgetId.includes(internalId);
  }

  clickGroup(group: TemplateGroup, propagation: boolean) {
    if (!this.disabledChangeGroup && this.chapter) {
      let accordionGroupId;
      this.chapter.payload.groups.forEach((g: TemplateGroup, index: number) => {
        if (g?.id === group?.id) {
          accordionGroupId = this.groupIdPrefix + index;
        }
      });

      if (accordionGroupId && this.acc) {
        if (!this.acc.isExpanded(accordionGroupId)) {
          this.acc.collapseAll();
          this.acc.expand(accordionGroupId);
        } else {
          // this.acc.collapse(accordionGroupId);
        }
      }
      if (propagation) {
        this.selectChapterGroup.emit(group);
      }
    }
  }

  isVisibleWidget(widget: UiWidget): boolean {
    return this.enabledWidgetInternalId.includes(widget.internalId) && (!widget?.opt || widget?.value); // && widget.editable;
  }

  private initialize(chapter: GetChapterResponse) {
    if (chapter) {
      this.payload = chapter?.payload;
      this.payload = {
        ...this.payload,
        groups: chapter?.payload?.groups.map(g => {
          // filtro html tolto .filter(w => w.type !== WidgetType.HTML)
          return {
            ...g,
            widgets: [...g.widgets].sort((w1, w2) => {
              return w1.order > w2.order ? 1 : -1;
            })
          };
        })
      };
      this.setEditGroup(this.status);
    }
  }

  private expandCurrentGroup() {
    if (!this.acc) {
      setTimeout(() => this.expandCurrentGroup(), 300);
    } else {
      if (this.selectedGroup) {
        this.chapter?.payload?.groups?.forEach((g, groupId) => {
            if (g.name === this.selectedGroup?.name) {
              const groupName = this.groupIdPrefix + groupId;
              this.acc.collapseAll();
              this.acc.expand(groupName);
            }
          }
        );
      }
    }
  }

  private setEditGroup(status: StoreTemplateStatus) {
    if (status && status.activedEditWidgetId) {
      this.payload?.groups?.forEach((g) => {
        g?.widgets.forEach((w) => {
          if (w.internalId === status.activedEditWidgetId) {
            this.currentEditGroup = g;
          }
        });
      });
    } else {
      this.currentEditGroup = null;
    }
  }
}
